import { MutationTree } from 'vuex';
import { BlacklistsState } from './types';

export const mutations: MutationTree<BlacklistsState> = {
    pushBlacklists:(state, data) => {
        state.blacklists = state.blacklists.concat(data)
    },
    setBlacklists:(state, data) => {
        state.blacklists = data
    },
    setBlackListItem:(state, data) => {
        state.blacklistItem = data
    },
    pushBlacklistContacts: (state, data) => {
        state.blacklistContacts = state.blacklistContacts.concat(data);
    },
    setBlacklistContacts:(state, data) => {
        state.blacklistContacts = data
    },
    setBlackListContactItem:(state, data) => {
        state.blacklistContactItem = data
    },
    pushBlacklistGenerals:(state, data) => {
        state.blacklistGenerals = state.blacklistGenerals.concat(data)
    },
    setBlacklistGenerals:(state, data) => {
        state.blacklistGenerals = data
    },
    setBlacklistGeneralItem:(state, data) => {
        state.blacklistGeneralItem = data
    },
};
